import React, { useEffect, useState } from "react";
import Viewer from "./Viewer";
import Notepad from "./Notepad";

const MathpixNotesTest = () => {

  const [ latexCode, setLatexCode ] = useState( '' );
  const [ clearKey, setClearKey ] = useState( 0 );

  useEffect( () => {
    clearKey && setLatexCode( '' );
  }, [ clearKey ] );

  return (
    <div style={ { padding : 20, display : 'inline-flex', width : '100%' } }>
      <Viewer>{ latexCode }</Viewer>
      <Notepad onNotes={ setLatexCode } onClear={ setClearKey } />
    </div>
  );

};

export default MathpixNotesTest;
